import { render } from "./HeadingCard.vue?vue&type=template&id=67d55696&scoped=true"
import script from "./HeadingCard.vue?vue&type=script&lang=js"
export * from "./HeadingCard.vue?vue&type=script&lang=js"

import "./HeadingCard.vue?vue&type=style&index=0&id=67d55696&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d55696"]])

export default __exports__